// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"9bf1f21d","141":"570613ce","205":"59d8184b","404":"3dc36e0f","483":"d6857d5d","626":"cb8417e0","817":"54ce7a98","985":"80295019"}[chunkId] + ".chunk.css";
};